// modelFields.js
import React, { useState } from 'react';
import { parseISO, parse, format } from 'date-fns';
import DatePicker from 'react-date-picker'; // Or any date picker library
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import DateOfBirthInput from './DateOfBirthInput';

// Convert dd/MM/yyyy to ISO string
export const parseToISODate = (dateString) => {
  try {
    const [day, month, year] = dateString.split('/').map((part) => parseInt(part, 10));
    if (isNaN(day) || isNaN(month) || isNaN(year)) throw new Error('Invalid date');
    return new Date(year, month - 1, day).toISOString();
  } catch (error) {
    console.error('Error parsing date:', error);
    return null;
  }
};

// Convert ISO string to dd/MM/yyyy
export const formatToDisplayDate = (isoString) => {
  if (!isoString) return 'N/A';
  try {
    return format(parseISO(isoString), 'dd/MM/yyyy');
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

const modelFields = [
  { label: 'Legal Name', field: 'legalName', placeholder: 'N/A' },
  {
    label: 'Date of Birth', field: 'dayOfBirth', placeholder: 'N/A', format: formatToDisplayDate,
    customRender: (model) => model.dayOfBirth === 0 && model.dayOfBirth === 0 && model.dayOfBirth === 0 ? 'N/A' : `${model.dayOfBirth || 'N/A'}/${model.monthOfBirth || 'N/A'}/${model.yearOfBirth || 'N/A'}`,
  },
  { label: 'Ethnicity', field: 'ethnicity', placeholder: 'Not specified' },
  { label: 'Booking Agency', field: 'bookingAgency?.ref', placeholder: 'N/A' },
  { label: 'Booker', field: 'model.booker?.ref', placeholder: 'N/A' },
  { label: 'Sex', field: 'sex', placeholder: 'N/A' },
  { label: 'Kids', field: 'kids', placeholder: 'N/A' },
  { label: 'Nationality', field: 'nationality', placeholder: 'N/A' },
  { label: 'Based Country', field: 'countryBasedIn', placeholder: 'N/A' },
  { label: 'Based City', field: 'cityBasedIn', placeholder: 'N/A' },
  { label: 'Eye Color', field: 'eyes', placeholder: 'N/A' },
  { label: 'Hair Color', field: 'hair', placeholder: 'N/A' },
  { label: 'Height', field: 'height', placeholder: 'N/A', suffix: ' cm' },
  { label: 'Bust', field: 'bust', placeholder: 'N/A', suffix: ' cm' },
  { label: 'Cup', field: 'cup', placeholder: 'N/A' },
  { label: 'Waist', field: 'waist', placeholder: 'N/A', suffix: ' cm' },
  { label: 'Hips', field: 'hips', placeholder: 'N/A', suffix: ' cm' },
  { label: 'Size', field: 'size', placeholder: 'N/A' },
  { label: 'Shoe Size', field: 'shoeSize', placeholder: 'N/A' },
  { label: 'Size (Jeans waist)', field: 'waistJeans', placeholder: 'N/A' },
  { label: 'Size (Jeans inseam)', field: 'inseamJeans', placeholder: 'N/A' },
];

/** TODO: the edit mode does not work for custom renders propperly, 
 * when displaying in edit mode it just takes the field value, 
 * thats obviosuly wrong for fields like dateOfBirth */
const PersonalInfo = ({ isEditMode, model, setModel }) => {

  const handleChange = (field, value) => {
      setModel((prev) => ({ ...prev, [field]: value }));
  };

  const handleDateChange = (day, month, year) => {
    console.log('dateChange: ', `${day}, ${month}, ${year}`)
    console.log('modelBefore: ', model);
    setModel((prev) => ({
      ...prev,
      monthOfBirth: month,
      dayOfBirth: day,
      yearOfBirth: year,
    }));
    console.log('modelAfter: ', model);
  }

  return (
    <div className='model-info-container'>
      {modelFields.map(({ label, field, placeholder, customRender, format, suffix, customDeStruct }) => {
        const displayValue = customRender ? customRender(model) : format ? format(model[field]) : model[field] || placeholder;

        return (
          <div key={field} className='info-item'>
            <strong className="info-label">{label}:</strong>
            {isEditMode ? (
              label === 'Date of Birth' ? (
                <DateOfBirthInput
                  day={model.dayOfBirth}
                  month={model.monthOfBirth}
                  year={model.yearOfBirth}
                  onDateChange={handleDateChange} />
              ) : (
                <input
                  type="text"
                  value={model[field] || ""}
                  placeholder={placeholder}
                  onChange={(e) => handleChange(field, e.target.value)}
                  className="info-input"
                />
              )
            ) : (
              <span className="info-value">{displayValue}{suffix}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PersonalInfo;
